// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/inventory/detail.css
// module id = 3514
// module chunks = 0